import { DirectiveOptions } from "vue";

let handleOutsideClick;

const closable: DirectiveOptions = {
  bind(el, binding, vnode) {
    handleOutsideClick = e => {
      e.stopPropagation();
      const { handler, except } = binding.value;
      if (e.target.classList.contains(except)) {
        //ModalQuote
        vnode.context![handler]();
      } else if (
        !(el == e.target || el.contains(e.target)) &&
        e.target.tagName.toLowerCase() != "a"
      ) {
        //ModalLogin and ModalUser
        vnode.context![handler]();
      }
    };
    document.addEventListener("click", handleOutsideClick);
    document.addEventListener("touchstart", handleOutsideClick);
  },

  unbind() {
    document.removeEventListener("click", handleOutsideClick);
    document.removeEventListener("touchstart", handleOutsideClick);
  }
};

export default closable;
